(() => {
  if (window.CelsoHeroEnrollmentCardPlacement) return;

  const initializedCards = new Set();

  const updateSlotState = (slot) => {
    const hasEnrollmentCard = Array.from(slot.children).some((child) =>
      child.matches('[data-enrollment-card]')
    );

    slot.classList.toggle('hero__enrollment-mobile-slot--active', hasEnrollmentCard);
  };

  const initializeCard = (card) => {
    if (initializedCards.has(card)) return;

    const hero = card.closest('.hero');
    const mobileSlot = hero?.querySelector('[data-hero-enrollment-mobile-slot]');
    const configuredBreakpoint = Number.parseInt(card.dataset.mobileSectionBreakpoint, 10);
    const sectionBreakpoint = Number.isFinite(configuredBreakpoint) ? configuredBreakpoint : 750;
    const sectionMediaQuery = window.matchMedia(`(max-width: ${sectionBreakpoint}px)`);

    if (!hero || !mobileSlot || !card.parentNode) return;

    const originalPosition = document.createComment('hero enrollment card position');
    card.parentNode.insertBefore(originalPosition, card);

    const updatePlacement = () => {
      if (sectionMediaQuery.matches) {
        mobileSlot.appendChild(card);
      } else if (originalPosition.parentNode) {
        originalPosition.parentNode.insertBefore(card, originalPosition.nextSibling);
      }

      updateSlotState(mobileSlot);
    };

    const cleanup = () => {
      if (typeof sectionMediaQuery.removeEventListener === 'function') {
        sectionMediaQuery.removeEventListener('change', updatePlacement);
      } else {
        sectionMediaQuery.removeListener(updatePlacement);
      }

      initializedCards.delete(card);
      originalPosition.remove();
      updateSlotState(mobileSlot);
    };

    if (typeof sectionMediaQuery.addEventListener === 'function') {
      sectionMediaQuery.addEventListener('change', updatePlacement);
    } else {
      sectionMediaQuery.addListener(updatePlacement);
    }

    card.heroEnrollmentPlacementCleanup = cleanup;
    initializedCards.add(card);
    updatePlacement();
  };

  const initialize = (root = document) => {
    if (root.matches?.('[data-enrollment-card]')) initializeCard(root);
    root.querySelectorAll?.('[data-enrollment-card]').forEach(initializeCard);
  };

  const cleanup = (root) => {
    const cards = [];

    if (root.matches?.('[data-enrollment-card]')) cards.push(root);
    root.querySelectorAll?.('[data-enrollment-card]').forEach((card) => cards.push(card));

    cards.forEach((card) => card.heroEnrollmentPlacementCleanup?.());
  };

  window.CelsoHeroEnrollmentCardPlacement = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => cleanup(event.target));
})();
